import { CHART_ELEMENT_ID, SpecificChartFunctionality } from 'finviz-charts/app/constants/common'
import { ChartLayoutWithGlobalState, type RootChartConfigObject } from 'finviz-charts/app/lib-export'

import {
  getChartLayoutSizeConfig,
  useChartLayoutWidthWatch,
} from '../../../main/modules/quote/hooks/use-chart-layout-width-watch'
import { getInitChartConfig } from '../getInitChartConfig'

interface ResizableChartLayoutWithGlobalStateProps {
  config: RootChartConfigObject
  specificChartFunctionality: SpecificChartFunctionality
}

export const ResizableChartLayoutWithGlobalState = ({
  config,
  specificChartFunctionality,
}: ResizableChartLayoutWithGlobalStateProps) => {
  useChartLayoutWidthWatch()
  const chartEl = document.getElementById(CHART_ELEMENT_ID)
  const chartConfig = getInitChartConfig(config)

  if (!chartConfig.specificChartFunctionality) {
    chartConfig.specificChartFunctionality = specificChartFunctionality
  }

  return (
    chartEl && (
      <ChartLayoutWithGlobalState
        config={{
          ...chartConfig,
          ...getChartLayoutSizeConfig(chartConfig),
        }}
        parentElement={chartEl}
      />
    )
  )
}
